import RegisterPage from "../../pages/register/RegisterPage";
import IndexInsuredPage from "../../pages/register/insured/IndexInsuredPage";
import VerifyEmailInformPage from "../../pages/register/VerifyEmailInformPage";
import ValidAccountPage from "../../pages/register/ValidAccountPage";
import InvalidAccountPage from "../../pages/register/InvalidAccountPage";
import InsuredContactPage from "../../pages/contact/InsuredContactPage";
import NotFound from "../../components/pages/NotFound";
import IndexPage from "../../pages/IndexPage";
import ProtectionDonneesPage from "../../pages/ProtectionDonneesPage";
import SecurityIcon from "@mui/icons-material/Security";
import Informationslegales from "../../pages/Informationslegales/Informationslegales";

export const ExtranetPublicRoutes = [

    // ############# Extranet Public ###############

    {
        name : "index",
        title : "Root",
        path : "/",
        component : IndexPage,
        private : false,
        showMenu: false,
        roles: []
    },
    {
        name : "info-legals",
        title : "Informations Légales",
        path : "/ui/informations-legales",
        component : Informationslegales,
        private : false,
        showMenu: false,
        roles: [],
    },
    {
        name : "register",
        title : "Bienvenue dans votre espace client",
        path : "/ui/register",
        component : RegisterPage,
        private : false,
        showMenu: false,
        roles: [],
    },
    {
        name : "register-insured",
        title : "Création de votre compte",
        path : "/ui/register/insured",
        component : IndexInsuredPage,
        private : false,
        showMenu: false,
        roles: [],
    },

    {
        name: "inform-verify-email",
        title: "Bravo ! Une dernière validation e-mail.",
        path: "/ui/inform-verify-email",
        component: VerifyEmailInformPage,
        private: false,
        showMenu: false,
        roles: []
    },
    {
        name: "valid-account",
        title: "Vérification d'e-mail valide",
        path: "/ui/valid-account",
        component: ValidAccountPage,
        private: false,
        showMenu: false,
        roles: []
    },
    {
        name: "invalid-account",
        title: "Vérification d'e-mail non valide",
        path: "/ui/invalid-account",
        param: "/:activationToken?",
        component: InvalidAccountPage,
        private: false,
        showMenu: false,
        roles: []
    },
    {
        name : "contact-insured",
        title : "Contact Assuré",
        path : "/ui/contact/insured",
        component : InsuredContactPage,
        showMenu: false,
        private : false,
        roles: []
    },

    {
        name : "protection-des-donnees",
        title : "Protection des données personnelles",
        path : "/ui/protection-des-donnees",
        component : ProtectionDonneesPage,
        showMenu: false,
        private : false,
        roles: [],
        icon: <SecurityIcon />
    },
    {
        name : "not-found",
        title : "404 Not Found",
        path : "*",
        component : NotFound,
        private : false,
        showMenu: false,
        roles: []
    },
    {
        name : "not-access",
        title : "400 Not Access",
        path : "/ui/not-access",
        component : NotFound,
        private : false,
        showMenu: false,
        roles: []
    }

]
